export default [
  // {
  //   name: 'MStiffHeiPRC',
  //   url: require('assets/fonts/MStiffHeiPRC-UltraBold.subset.ttf'),
  //   options: {},
  // },
  // {
  //   name: 'MStiffHeiPRC',
  //   url: require('assets/fonts/MStiffHeiPRC-UltraBold.subset.ttf'),
  //   options: {
  //     weight: 'bold',
  //   },
  // },
]
